import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Util } from 'src/shared/util/util';

@Component({
  selector: 'task-suggestion-card',
  templateUrl: 'task-card.component.html',
  styleUrls: ['task-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TaskCardComponent {
  @Input() set type(value: 'regular' | 'suggested') {
    this._type = value;
  }
  get type(): 'regular' | 'suggested' {
    return this._type;
  }
  private _type: 'regular' | 'suggested' = 'regular';
  @Input() title: string;
  @Input() priorityIcon: string;
  @Input() address: string;
  @Input() showArrowOnly = false;
  @Input() checkedUsers: any[] = [];
  @Input() allUsers: any[] = [];
  @Input() checkedJobs: any[] = [];
  @Input() filteredJobs: any[] = [];
  @Input() allJobs: any[] = [];
  @Input() dueDate: string;
  @Input() jobSearchForm: any;
  @Output() cardClick = new EventEmitter<void>();
  @Output() rejectClick = new EventEmitter<void>();
  @Output() acceptClick = new EventEmitter<void>();
  @Output() userCheck = new EventEmitter<{user: any, event: any}>();
  @Output() jobCheck = new EventEmitter<{job: any, event: any}>();
  @Output() jobMenuOpen = new EventEmitter<void>();
  @Output() addJobClick = new EventEmitter<void>();
  @Output() goToJobClick = new EventEmitter<{job: any, event: any}>();

  constructor(public util: Util) {}

  get isSuggested(): boolean {
    return this.type === 'suggested';
  }

  getUserIcon(): string {
    if (!this.checkedUsers?.length) {
      return 'none';
    }
    if (this.checkedUsers[0]?.type === 'concierge') {
      return 'concierge';
    }
    return 'user';
  }

  getInitials(name: string): string {
    if (!name) {
      return 'BA';
    }
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return parts[0][0] + parts[1][0];
    }
    return name.substring(0, 2);
  }

  onCardClick() {
    this.cardClick.emit();
  }

  onRejectClick(event: Event) {
    event.stopPropagation();
    this.rejectClick.emit();
  }

  onAcceptClick(event: Event) {
    event.stopPropagation();
    this.acceptClick.emit();
  }

  onUserCheck(user: any, event: any) {
    this.userCheck.emit({ user, event });
  }

  onJobCheck(job: any, event: any) {
    this.jobCheck.emit({ job, event });
  }

  onJobMenuOpen(event: Event) {
    event.stopPropagation();
    this.jobMenuOpen.emit();
  }

  onAddJobClick() {
    this.addJobClick.emit();
  }

  onGoToJob(job: any, event: Event) {
    this.goToJobClick.emit({ job, event });
  }

  isDueDateInPast(dueDate: string): boolean {
    if (!dueDate) {
      return false;
    }
    return new Date(dueDate) < new Date();
  }

  formatDueDate(dueDate: string): string {
    if (!dueDate) {
      return '';
    }
    const date = new Date(dueDate);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
}
